// import * as d3_array from 'd3-array'
// import * as dayjs from 'dayjs'


function addressZoz(d) {
    return [d.region, d.settlement_name, d.street, d.street_number].join(", ")
}

function addressSoc(d) {
    return [d.region, d.city, d.street, d.building_num].join(", ")
}

function orgnameSoc(d) {
    return d.organisation.title
}

function orgnameZoz(d) {
    return d.name
}

function personZoz(d) {
    let doc = d.hospitality_doctor[0];
    if (!doc) return "";

    return [doc.position, doc.last_name, doc.name, doc.surname].filter(v => v).map(v => v.trim()).join(" ")
}

function personSoc(d) {
    return d.coordinator.name
}


function address(d, section) {
    if (section === 'soc') return addressSoc(d);
    return addressZoz(d);
}

function orgname(d, section) {
    if (section === 'soc') return orgnameSoc(d);
    return orgnameZoz(d);
}

function person(d, section) {
    if (section === 'soc') return personSoc(d);
    return personZoz(d);
}

function prep(d) {
    let res = [];
    if (d.buprenorfin) res.push('Бупренорфін');
    if (d.methadon) res.push('Метадон');
    return res.join(" ");
}


function normalize(s) {
    if (!s) return "";
    return s.trim().toUpperCase();
}

function search_field(d, s) {
    return [address(d, s), orgname(d, s), person(d, s), prep(d, s)].filter(v => v).map(v => v.trim()).join(" ")
}

function filter(data, term) {
    if (!term) return data;
    let normalizedTerm = normalize(term);
    if (data[0].data !== undefined) {
        return data.map(d => ({
            ...d,
            data: d.data.filter(innerD => normalize(innerD.search_field).indexOf(normalizedTerm) >= 0)
        })).filter(d => d.data.length > 0);
    }
    return data.filter(d => normalize(d.search_field).indexOf(normalizedTerm) >= 0)
}

function google_maps_link(latlon) {
    if (!latlon || !latlon[0] || !latlon[1]) return null;
    let lat = latlon[0];
    let lon = latlon[1];
    return `https://www.google.com/maps?q=${lat},${lon}`;
}

export {
    address,
    filter,
    search_field,
    google_maps_link,
}